import { ErrorHandler, inject, Injectable } from '@angular/core';
import { CommunityService } from '../services/community.service';
import { PushToGoogleTagManager } from './google-tag-manager';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private lastErrorMessage = '';
  private lastErrorTime = 0;

  private communityService = inject(CommunityService);

  handleError(error: unknown): void {
    const message = error instanceof Error ? error.message : String(error);
    const stack =
      error instanceof Error
        ? (error.stack ?? 'No stack trace available')
        : 'No stack trace available';

    const now = Date.now();
    const isDuplicate = message === this.lastErrorMessage && now - this.lastErrorTime <= 1000;

    if (!isDuplicate) {
      this.lastErrorMessage = message;
      this.lastErrorTime = now;

      PushToGoogleTagManager({
        eventName: 'js_error',
        eventType: 'angular_error',
        eventValue: 'Message: ' + message + '. Stack Trace: ' + stack
      });

      const app = window.location.href.includes('homeconfigurator') ? 'homeconfigurator' : 'myscp';

      const logUrl = `${this.getArgoUrl()}/api/dia`;
      const payload = JSON.stringify({
        Event: 'js_error',
        App: app,
        ErrorMessage: message,
        ErrorStack: stack,
        Origin: window.location.origin,
        Href: window.location.href,
        Community: this.communityService.current.Name,
        CommunityId: this.communityService.current.CommunityId,
        Client: this.communityService.current.ClientName,
        Project: this.communityService.current.ProjectId
      });

      fetch(logUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: payload,
        keepalive: true
      }).catch(() => {
        //purposefully blank. Do not allow the event to throw an error if call fails
      });
    }

    console.error(error);
  }

  private getArgoUrl() {
    if (window.location.origin.includes('ml3ds-iconstage.com'))
      return 'https://argo.ml3ds-stage.com';
    else if (window.location.origin.includes('-rt-')) return 'https://argo.ml3ds-rt-stage.com';
    else if (window.location.origin.includes('-uat-')) return 'https://argo.ml3ds-uat-stage.com';
  }
}
